import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { FaCheck } from 'react-icons/fa'
import Select from 'react-select';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { RiDeleteBin6Line } from 'react-icons/ri';
import axios from 'axios'




const Notices = ({ setLoading, userData }) => {

    const [memberType, setMemberType] = useState('');
    const [academicYears, setAcademicYears] = useState([]);
    const [classes, setClasses] = useState([]);

    const [selectedAY, setSelectedAY] = useState(null);
    const [selectedClass, setSelectedClass] = useState(null);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [insNotice, setInsNotice] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const [title, setTitle] = useState([]);
    const [date, setDate] = useState();
    const [desc, setDesc] = useState();
    const [showDelete, setShowDelete] = useState(false);
    const [selectedNotice, setSelectedNotice] = useState('');
    const [filterAY, setFilterAY] = useState([]);
const [selectedFilterAY, setSelectedFilterAY] = useState(null);

    // Fetch academic years
    const fetchAcademicYears = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-academic-years');
            if (response.ok) {
                const data = await response.json();
                setFilterAY(data);
                // Assuming API returns array of { id, name } or similar
                const options = data.map(ay => ({
                    value: ay.year,
                    label: ay.title || ay.year || `AY ${ay.id}`,
                }));
                setAcademicYears(options);

     if (data.length > 0) {
                const latestAY = data[0].year;

                setSelectedFilterAY(latestAY);

                fetchNoticeList(latestAY);
            }

            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching academic years:', error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch classes
    const fetchClasses = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-classes');
            if (response.ok) {
                const data = await response.json();
                // Map classes to react-select options
                const options = data.map(cls => ({
                    value: cls.id,
                    label: cls.class_name,
                    sections: cls.sections,
                }));
                setClasses(options);
            } else {
                console.error('Failed to fetch classes');
            }
        } catch (error) {
            console.error('Error fetching classes:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
            fetchAcademicYears();
        setSelectedAY(null);
        setSelectedClass(null);
        setAcademicYears([]);
        setClasses([]);

        if (memberType === 'Student') {
            // fetchAcademicYears();
            fetchClasses();
        }
    }, [memberType]);

    const handleMemberTypeChange = e => {
        setMemberType(e.target.value);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formData = new FormData();

            if (selectedAY) {
                formData.append('year', selectedAY.value);
            }

            if (selectedClass) {
                const classPayload = {
                    classId: selectedClass.value,
                    className: selectedClass.label
                };
                formData.append('class_id', JSON.stringify(classPayload));
            }

            formData.append('title', title);
            formData.append('title_date', date);
            formData.append('role', memberType);
            formData.append('description', desc);

            const response = await axios.post('https://api.kcian.in/add-institute-notice', formData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            setResponse2({ message: 'Notice Added Successfully.', status: 'success' });
            fetchNoticeList();
            setTitle([]);
            setDate();
            setMemberType('');
            setDesc('');

            setLoading(false);
            setTimeout(() => {
                setResponse2('');
            }, 2000);

        } catch (error) {
            console.error('Error submitting form:', error);
            setLoading(false);
        }
    };


    const fetchNoticeList = async () => {
        setLoading(true);
        try {
    let url = 'https://api.kcian.in/get-institute-notice';

        if (selectedFilterAY) {
            url += `?year=${selectedFilterAY}`;
        }

        const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setInsNotice(data);
                setLoading(false);
            } else {
                setLoading(false);
                console.error('Failed to fetch');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
    if (selectedFilterAY) {
        fetchNoticeList(selectedFilterAY);
    }
}, [selectedFilterAY]);

    // useEffect(() => {
    //     fetchNoticeList();
    // }, []);

    const filteredNotice = insNotice.filter(m => {
        const term = searchTerm.toLowerCase();
        return (
            (m.class_id?.className?.toLowerCase() || '').includes(term) ||
            (m.role?.toLowerCase() || '').includes(term) ||
            (m.date?.toLowerCase() || '').includes(term)
        );
    });


    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} `;
    };


    const handleShowDelete = (ntc) => {
        setShowDelete(true);
        setSelectedNotice(ntc)
    }


                  const handleDelete = async (nId) => {
                setLoading(true);
    try {
      const response = await fetch(`https://api.kcian.in/delete-institute-notice/${nId}`, {
        method: 'DELETE',
      });

                setLoading(false);

      if (response.ok) {
setInsNotice((prevData) => prevData.filter((product) => product.id !== nId));
        setShowDelete(false);
        fetchNoticeList();
        setResponse2({ message: 'Notice Deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
                        setLoading(false);
      console.error('Error deleting data:', error);
    }
  };




    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='Utilities' message2='Notice Board' />

                    {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                    <div className='row'>

                        <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
                            <div className="profile-card">
                                <p className="profile-heading">Add Notice</p>
                                <form className='mt-4' onSubmit={handleSubmit}>

                                    <div className='profile-input-area mb-4'>
                                        <label className='profile-badge'>Select Role*</label>
                                        <select
                                            name='role'
                                            value={memberType}
                                            onChange={handleMemberTypeChange}
                                            className='profile-input'
                                            required
                                        >
                                            <option value=''>Select Member Type..</option>
                                            <option value='Student'>Student</option>
                                            <option value='Teacher'>Teacher</option>
                                            <option value="Librarian">Librarian</option>
                                            {/* <option value="Hostel">Hostel</option> */}
                                            <option value="Transport">Transport</option>
                                        </select>
                                    </div>



                                    {memberType === 'Student' && (
                                        <>
                                            <div className='profile-input-area mb-4 border-0'>
                                                <label className='profile-badge'>Academic Year*</label>
                                                <Select
                                                    options={academicYears}
                                                    value={selectedAY}
                                                    name='year'
                                                    className='profile-input'
                                                    onChange={setSelectedAY}
                                                    placeholder="Select Academic Year"
                                                    isClearable
                                                />
                                            </div>

                                            <div className='profile-input-area mb-4 border-0'>
                                                <label className='profile-badge'>Class*</label>
                                                <Select
                                                    options={classes}
                                                    value={selectedClass}
                                                    onChange={setSelectedClass}
                                                    className='profile-input'
                                                    placeholder="Select Class"
                                                    isClearable
                                                />
                                            </div>


                                        </>
                                    )}


                                    <div className='profile-input-area mb-4'>
                                        <label className='profile-badge'>Notice Title*</label>
                                        <input
                                        type='text'
                                            className='profile-input'
                                            value={title}
                                            onChange={e => setTitle(e.target.value)}
                                            placeholder="Enter Notice Title"
                                            required
                                        />
                                    </div>

                                    <div className='profile-input-area mb-4'>
                                        <label className='profile-badge'>Description*</label>
                                        <textarea
                                            type='text'
                                            className='profile-input'
                                            value={desc}
                                            onChange={e => setDesc(e.target.value)}
                                            placeholder="Enter Notice Description"
                                            required
                                        />
                                    </div>

                                    <div className='profile-input-area mb-4'>
                                        <label className='profile-badge'>Date*</label>
                                        <input
                                            type='date'
                                            className='profile-input'
                                            value={date}
                                            onChange={e => setDate(e.target.value)}
                                            required
                                        />
                                    </div>



                                    <div className='text-center'>
                                        <button type='submit' className='profile-btn'>
                                            <FaCheck /> Save
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>


                        <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                            <div className='profile-card'>

                                <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                    <span className="profile-heading align-content-center">Notice List</span>


<div className='d-md-flex'>
    <div className='col-lg-6'>
            <select
  className="profile-input rounded-0 my-1"
  value={selectedFilterAY}
  onChange={(e) => setSelectedFilterAY(e.target.value)}
>
  <option value="">Select Year</option>

  {filterAY.map((ay) => (
    <option key={ay.year} value={ay.year}>
      {ay.year}
    </option>
  ))}
</select>
</div>
                        <div className='profile-input-area ms-auto col-lg-6 border-0'>
                                        <input
                                            type='text'
                                            name='search'
                                            className='profile-input border-bottom rounded-0'
                                            placeholder='Search...'
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
</div>


                              
                                </div>




                                <div className='table-responsive'>
                                    <table className='w-100'>

                                        <thead className='account-thead'>
                                            <th className='rounded-start-4'>S No</th>
                                            <th>Posted On</th>
                                            <th>Title</th>
                                            <th>Notice</th>
                                            <th>For</th>
                                            <th>Class</th>
                                            <th className='rounded-end-4'>Activity</th>
                                        </thead>

                                        {filteredNotice.map((mem, index) => (
                                            <tr className='account-tr' key={mem.id}>
                                                <td>{index + 1}</td>
                                                <td>{formatDate(mem.title_date) || '--'}</td>
                                                <td>{mem.title || '--'}</td>
                                                <td>{mem.description}</td>
                                                <td>{mem.role}</td>
                                                <td>

                                                    {mem.role === 'Student' && mem.class_id
                                                        ? (() => {
                                                            try {
                                                                const parsed = JSON.parse(mem.class_id);
                                                                return parsed.className || '';
                                                            } catch {
                                                                return '';
                                                            }
                                                        })()
                                                        : '--'}
                                                </td>

                                                <td>
                                                    <RiDeleteBin6Line className='account-icon1' onClick={() => handleShowDelete(mem)} />
                                                </td>
                                            </tr>
                                        ))}


                                    </table>
                                </div>

                            </div>
                        </div>

                    </div>


                </div>
            </section>


            {showDelete && (
                <>
                    <section className='ins-dialog'>
                        <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

                            <p className='ins-dialog-heading text-danger'>Remove This Notice!</p>

                            <div className='table-responsive'>
                                <table className='w-100'>

                                    <thead className='account-thead'>
                                        <th className='rounded-start-4'>Posted On</th>
                                        <th>Title</th>
                                        <th>Notice</th>
                                        <th>For</th>      <th className='rounded-end-4'>Class</th>
                                    </thead>

                                    <tr className='account-tr'>
                                                <td>{formatDate(selectedNotice.title_date) || '--'}</td>
                                                <td>{selectedNotice.title || '--'}</td>
                                                <td>{selectedNotice.description}</td>
                                                <td>{selectedNotice.role}</td>
                                                <td>

                                                    {selectedNotice.role === 'Student' && selectedNotice.class_id
                                                        ? (() => {
                                                            try {
                                                                const parsed = JSON.parse(selectedNotice.class_id);
                                                                return parsed.className || '';
                                                            } catch {
                                                                return '';
                                                            }
                                                        })()
                                                        : '--'}
                                                </td>
                                    </tr>

                                </table>
                            </div>

                            <p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Notice will be permanently removed.</p>

                            <button className='profile-btn me-2' onClick={() => handleDelete(selectedNotice.id)}>Remove</button>
                            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


                        </div>
                    </section>
                </>
            )}

        </>
    )
}

export default Notices